import { withStyles } from '@material-ui/core/styles';
import { IconButton } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    publishDialog:{
        padding:"18px 24px",
        boxSizing: "border-box",
        borderRadius:"2px",
        backgroundColor: theme.ModalBGColor,
        boxShadow: "2px 2px 4px black"
    },
    publishDialogTitle:{
        fontSize:14,
        fontWeight:"600",
        lineHeight:"20px",
        color: theme.HeaderSelectedText,
        padding:0
    },
    publishDialogContent:{
        fontSize:theme.textFontSize,
        color: theme.TextColor,
        overflow:"hidden",
        padding:"16px 0px"
    },
    dialogButtonStyle:{
        fontSize:14,
        textTransform:"none",
        borderRadius:"2px",
        margin:0,
        width:"47%",
    },
    dialogAction:{
        justifyContent:"space-between",
        margin:0
    },
    publishCloseIcon:{
        padding:"0px",
        float:"right",
        color:theme.HeaderDefaultTextColor,
        '&:hover':{
            backgroundColor: theme.ModalBGColor,
            color:theme.HeaderSelectedText
        }
    },
    boldFont:{
        fontWeight:600
    },
    warningInfo:{
        paddingTop: 16,
        display: "none"
    },
    warning:{
        color: theme.ErrorMessageColor
    },
})

const PublishDialog = props => {
    const {classes,show,onClose,publish} = props;
        return(
            <Dialog
            open={show}
            onClose={onClose}
            aria-labelledby="publish-dialog"
            classes={{paper:classes.publishDialog}}>
                <DialogTitle disableTypography={true} classes={{root:classes.publishDialogTitle}} id="publish-dialog">Publish To Dock
                    <IconButton aria-label="Close" classes={{root:classes.publishCloseIcon}} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent classes={{root:classes.publishDialogContent}}>
                    <div className={classes.boldFont}>Are you sure you want to send the plan to dock?</div>
                    <div className={classes.warningInfo}>
                        <span className={classes.warning}>Note: </span> Changes after this will be auto-saved.
                    </div>
                </DialogContent>
                <DialogActions classes={{root:classes.dialogAction}}>
                    <Button  
                    variant="outlined" 
                    color="primary" 
                    size="medium" 
                    className={classes.dialogButtonStyle} 
                    onClick={onClose}>
                        Cancel
                    </Button>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    size="medium" 
                    className={classes.dialogButtonStyle} 
                    onClick={publish}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
}

export default withStyles(styles)(PublishDialog)